<template>
  <div>
    <div id="entirety">
      <div id="headNav">
        <h6 class="head_text" @click="isCollapse = !isCollapse">傲举招聘管理系统</h6>
        <div style="margin-right: 4%">
          <div style="display: flex; width: 100%" @click="partserch(), IsConterShow = true;">
            <el-dropdown>
              <el-badge :value="readNUm" :max="99" class="item">
                <el-button type="text" icon="el-icon-message-solid" size="mini"
                  style=" font-size: 25px;color: white;top: -15px;position: relative;"></el-button>
              </el-badge>
              <el-dropdown-menu slot="dropdown" style="max-height: 300px;" class="scrollHidden">
                <el-dropdown-item v-if="tableData.length == 0">现在还有收到通知</el-dropdown-item>
                <!-- <div v-for="(item, index) in tableData" :key="index">

                  <el-dropdown-item :command="item.noticeId" style="position: relative;padding: 10px 25px 5px;">
                    <p style="display: inline-block;vertical-align: middle;" @click="getRead(item)">{{
                      item.noticeContent }}</p>
                    <el-button type="text" icon="el-icon-close" size="mini"
                      style="position: absolute;right: 0;top: -8px;color: red;"
                      @click="deleteRead(item.noticeId)"></el-button>
                    <p v-if="item.noticeStatus == 1"
                      style="width: 8px;height: 8px;background-color: red;border-radius: 100%;display: inline-block;vertical-align:middle;margin-left: 10px;">
                    </p>
                  </el-dropdown-item>
                </div> -->

              </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown @command="handleCommand" style="color: white;font-size: 19px;">
              <span class="el-dropdown-link">
                {{ username }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a">退出登录</el-dropdown-item>
                <el-dropdown-item command="b">修改密码</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>

      <div style="display: flex; width: 100%; height: calc(100% - 60px)">
        <div id="sideNav" class="scrollHidden" v-if="!flagShow">
          <el-menu :default-active="$route.name" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
            active-text-color="#0055ff" background-color="#121212" text-color="#fff" router :collapse="isCollapse"
            unique-opened>
            <template v-for="(item, index) in myRouter">
              <el-menu-item :key="item.authId" :index="getRouteName(item)" :route="item.authUrl" v-if="!item.children || item.children.length === 0">
                <i :class="item.authIcon"></i>
                <span slot="title">{{ item.authName }}</span>
              </el-menu-item>
              <el-submenu :key="'sub-' + item.authId" :index="String(index)" v-if="item.children && item.children.length > 0">
                <template slot="title">
                  <i :class="item.authIcon"></i>
                  <span>{{ item.authName }}</span>
                </template>
                <el-menu-item v-for="child in item.children" :key="child.authId" :index="getRouteName(child)" :route="child.authUrl">
                  <i :class="child.authIcon"></i>
                  <span slot="title">{{ child.authName }}</span>
                </el-menu-item>
              </el-submenu>
            </template>
          </el-menu>
        </div>

        <div id="main">
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </div>
      </div>
    </div>
    <el-dialog :title="conterstr.noticeTitle" :visible.sync="Isconter" width="70%" top="8vh">
      <div style="margin: 15px;">
        {{ conterstr.noticeContent }}
      </div>
      <p style="margin: 15px;">通知时间:{{ conterstr.createtime }}</p>
    </el-dialog>
    <el-dialog title="消息列表" :visible.sync="IsConterShow" width="70%" top="8vh">
      <div style="width: 100%">
        <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
          :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
          :checkbox-option="checkboxOption" row-key-field-name="dataIndex" :cellSelectionOption="cellSelectionOption"
          style="width: 100%" />
        <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
      </div>
      <div class="table-pagination">
        <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
          :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
          @on-page-size-change="pageSizeChange" />
      </div>
    </el-dialog>
    <el-dialog title="修改密码" :visible.sync="updataPw" width="25%" center>
      <p>新密码</p>
      <el-input v-model="suPw" autocomplete="off"></el-input>

      <span slot="footer" class="dialog-footer">
        <el-button @click="updataPw = false; suPw = ''">取 消</el-button>
        <el-button type="primary" @click="updataPwclick">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getIvNoticeList, getIvNoticeUnReadNum, deleteIvNoticeRead, updateIvNoticeRead, updateIvUserPw
} from "../api/api";
import { checkPathInAuth, fetchAndStoreAuthRouter, getFirstAccessibleRoute, getStoredAuthRouter } from "../utils/authRouter";
export default {
  name: "Home",
  data() {
    return {
      iuId: '',
      suPw: '',
      updataPw: false,
      formDatas: {
        currentPage: 1,
        pageSize: 10,
      },
      columns: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          align: "center",
          fixed: 'left',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },

        {
          field: "noticeTitle",
          key: "noticeTitle",
          title: "标题",
          align: "center",
          width: 200,

        },
        {
          field: "noticeContent",
          key: "noticeContent",
          title: "内容",
          align: "center",


        },
        {
          field: "createtime",
          key: "createtime",
          title: "通知时间",
          align: "center",
          width: 200,

        },
        {
          field: "",
          key: "d",
          title: "操作",
          width: 200,
          fixed: 'right',
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {
                  row.noticeStatus == 1 ? <el-button
                    size="mini"
                    type="text"
                    on-click={() => this.getRead(row)}
                  >
                    已读
                  </el-button> : ''
                }

                <el-button
                  size="mini"
                  type="text"
                  style="color: red"
                  on-click={() => this.deleteRead(row.noticeId)}
                >
                  删除
                </el-button>

              </span>
            );
          },
        }
      ],
      cellSelectionOption: {
        // disble cell selection
        enable: true,
      },
      totalCount: 100,
      pageIndex: 1,
      pageSize: 10,
      selectedRowKeysCollection: [],
      checkboxOption: {
        // 可控属性
        selectedRowKeys: [],
        // 行选择改变事件
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          this.changeSelectedRowKeys(row, isSelected);
        },
        // 全选改变事件
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          this.changeSelectAll(isSelected, selectedRowKeys);
        },
      },
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
      tableDataCopy: [],
      tableHight: 520,
      tableData: [],
      IsConterShow: false,

      flag: '',
      flagShow: false,
      iuPost: '',
      Isconter: false,
      conterstr: '',
      post: localStorage.getItem("post"),
      iuId: localStorage.getItem("iuId"),
      username: "",
      readNUmArr: [],
      readNUm: '',
      isCollapse: false,
      authLoading: false,
      myRouter: [], // 动态权限菜单
    };
  },
  created() {
    //console.log("首页");
    this.iuId = localStorage.getItem("iuId");
    this.username = localStorage.getItem("iuName");
    document.title = "傲举招聘管理系统";
    this.iuPost = localStorage.getItem("iuPost");

    // 从 localStorage 加载权限菜单
    this.loadAuthMenu();

    this.flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    //console.log(this.flag);
    if (this.flag) {
      this.flagShow = true;

      // this.$router.replace('/Home/recordingh5')
    }

    this.partserch();
    getIvNoticeUnReadNum().then(res => {
      if (res.data == 0) {
        this.readNUm = '';
        return
      }
      this.readNUm = res.data
    })
    this.refreshAuthMenu()
  },
  watch: {},

  activated() {
    this.username = localStorage.getItem("iuName");
    document.title = "傲举招聘管理系统";
    this.watchFlag = true;
    // 重新加载权限菜单
    this.loadAuthMenu();
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = this.windheight - 200 - this.windheight * 0.04;
    });
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = val - 200 - val * 0.04;
        }
      });
    },
    "$store.state.HomeNum"(val) {
      this.$nextTick(() => {
        this.getlist()
      });
    },
  },
  deactivated() {
    this.watchFlag = false;
    this.IsConterShow = false
  },
  methods: {
    loadAuthMenu() {
      this.myRouter = getStoredAuthRouter();
    },
    async refreshAuthMenu() {
      if (this.authLoading) {
        return;
      }

      this.authLoading = true;

      try {
        const authList = await fetchAndStoreAuthRouter();
        this.myRouter = authList;
        this.ensureRoutePermission(authList);
      } catch (error) {
        console.error('refresh auth router failed:', error);

        if (!this.myRouter.length) {
          this.$message.error('鉴权失败，请重新登录');
          this.$router.replace('/dologin');
        }
      } finally {
        this.authLoading = false;
      }
    },
    ensureRoutePermission(authList) {
      if (!authList || authList.length === 0) {
        this.$message.warning('暂无访问权限');
        this.$router.replace('/dologin');
        return;
      }

      const currentPath = this.$route.path;
      const hasPermission = currentPath !== '/Home' && checkPathInAuth(currentPath, authList);

      if (hasPermission) {
        return;
      }

      const firstRoute = getFirstAccessibleRoute(authList);
      if (firstRoute && firstRoute !== currentPath) {
        this.$router.replace(firstRoute);
        return;
      }

      if (!firstRoute) {
        this.$message.warning('暂无访问权限');
        this.$router.replace('/dologin');
      }
    },
    updataPwclick() {
      if (this.suPw == '') {
        this.$message({
          type: 'warning',
          message: '请输入密码!'
        })
      } else {
        updateIvUserPw({ iuPw: this.suPw }).then(res => {
          this.$message({
            type: 'success',
            message: '修改成功!'
          })
          this.updataPw = false;
          this.suPw = '';

        })
      }
    },
    handleCommand(command) {
      if (command == "a") {
        this.Out()
      } else {
        this.updataPw = true;
      }
    },
    partserch() {
      this.formDatas.currentPage = 1;
      this.formDatas.checkStatus = 2;
      getIvNoticeList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.tableDataCopy = res.data;
        this.totalCount = res.total;
        this.resetSelectedRowKeys();

      });
      getIvNoticeUnReadNum().then(res => {
        if (res.data == 0) {
          this.readNUm = ''
          return
        }
        this.readNUm = res.data

      })
    },
    resetSelectedRowKeys() {
      //console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
      this.checkboxOption.selectedRowKeys = [];

      const selectedRowKeysCollection = this.selectedRowKeysCollection;

      if (selectedRowKeysCollection.length) {
        this.tableData.forEach((item) => {
          if (selectedRowKeysCollection.indexOf(item.auId) > -1) {
            //console.log(item);
            this.checkboxOption.selectedRowKeys.push(item.auId);
          }
        });
      }
    },
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.partserch();
    },
    pageNumberChange(pageIndex) {
      //console.log(pageIndex);
      this.formDatas.currentPage = pageIndex;
      this.formDatas.checkStatus = 2;
      getIvNoticeList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.tableDataCopy = res.data;
        this.totalCount = res.total;
        this.resetSelectedRowKeys();
        // this.$message({
        //     type: "success",
        //     message: "搜索成功!",
        // });
      });

    },
    getRead(val) {
      // this.conterstr = val;
      // this.Isconter = true;
      if (val.noticeStatus == 1) {
        updateIvNoticeRead({ noticeIds: val.noticeId }).then(res => {
          this.partserch()
        })
      }
    },
    getlist() {
      getIvNoticeList().then(res => {
        //console.log(res.data);
        this.readNUmArr = res.data
      })
      getIvNoticeUnReadNum().then(res => {
        if (res.data == 0) {
          this.readNUm = ''
          return
        }
        this.readNUm = res.data

      })
    },
    deleteRead(id) {
      this.$confirm("是否确定要删除通知吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteIvNoticeRead({ noticeIds: id }).then(res => {
            this.partserch()
          })

        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        })
    },
    Out() {
      localStorage.clear();
      this.$router.push({
        path: "/doLogin",
      });
    },
    // 从 authRemark 提取路由 name（去掉 # 前缀）
    getRouteName(item) {
      if (item.authRemark) {
        return item.authRemark.replace('#', '');
      }
      // 如果没有 authRemark，从 authUrl 提取
      if (item.authUrl) {
        const parts = item.authUrl.split('/');
        return parts[parts.length - 1];
      }
      return '';
    },
    handleOpen(key, keyPath) {
    },


    handleClose(key, keyPath) {
      //console.log(key, keyPath);
    },
  },
};
</script>

<style scoped="scoped">
.item {
  position: absolute;
  top: 5px;
  right: 20px;
  margin-top: 15px;
  margin-right: 20px;
}

#entirety {
  width: 100%;
  height: 100vh;
}

#headNav {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #121212;
  display: flex;
  justify-content: space-between;
}

.scrollHidden {
  overflow-y: scroll;
}

.head_text {
  color: white;
  margin-left: 2em;
  font-size: 19px;
  margin-left: 2%;
  width: 45%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#sideNav {
  /* width: 13%; */
  height: 100%;
  background-color: #121212;
  overflow-y: scroll;
  overflow-x: hidden;
}

#main {
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: hidden;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 230px;
  min-height: 400px;
}

div /deep/ .el-submenu__icon-arrow {
  right: 40px;
}

/* 隐藏滚动条 */
.scrollHidden::-webkit-scrollbar {
  display: none;
}
</style>
